// extracted by mini-css-extract-plugin
module.exports = {"mlfsTable":"SimpleMlfsTable_mlfsTable_1AGu0"};